<template>
	<PrivateOrderMonitoring type="admin" />
	<!-- <div>
	</div> -->
</template>

<script>
import { mapGetters } from 'vuex';
import PrivateOrderMonitoring from '@/components/private-orders/index.vue';

export default {
	name: 'SellerPrivateOrder',
	components: {
		PrivateOrderMonitoring,
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
};
</script>
